import { createFileRoute, notFound } from "@tanstack/react-router";
import PartsCatalogTag from "@/pages/PartsCatalogTag";
import { countTagProducts } from "@/lib/seo-status";

export const Route = createFileRoute("/producttag/$slug")({
  // An empty tag hub is a Soft 404 in Search Console — answer 404 instead of
  // rendering an empty collection page with a 200.
  loader: async ({ params }) => {
    const count = await countTagProducts(params.slug);
    if (count === 0) throw notFound();
    return { productCount: count };
  },
  // Thin hubs (1–2 products, or abbreviation-only slugs) get a server-rendered
  // noindex so crawlers see it in the HTML instead of after hydration.
  head: ({ params, loaderData }) => {
    const stripped = params.slug.replace(/-/g, "");
    const count = loaderData?.productCount ?? null;
    const thin =
      (count !== null && count < 3) || stripped.length <= 3 || !/[aeiou]/i.test(stripped);
    return {
      meta: [{ name: "robots", content: thin ? "noindex,follow" : "index,follow" }],
      links: [
        {
          rel: "canonical",
          href: `https://www.rexandsonsrvs.com/producttag/${params.slug}`,
        },
      ],
    };
  },
  component: PartsCatalogTag,
});
